import * as React from 'react'
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import {useEffect} from "react";

export default function PaymentQ({handlePaymentQ, paymentQValue, emailValue, setEmailValue, dinnerCost}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div style={{ padding: "8px", fontStyle: "italic" }}>
        Meal costs <strong>{dinnerCost} per person</strong>
      </div>
      <div className="mason-question">

        <FormControl>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={paymentQValue}
            onChange={(e) => handlePaymentQ(e, 7)}
          >
            <FormControlLabel value="Transfer" control={<Radio />} label="Transfer" />
            <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
          </RadioGroup>
        </FormControl>
      <div>

      <Typography
        variant="h5"
        align="left"
        gutterBottom
        style={{ fontWeight: "600", padding: "24px 0px 16px" }}
      >
        Enter email address below to receive email confirmation
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Enter your email"
        value={emailValue}
        onChange={(e) => setEmailValue(e.target.value)}
        style={{ backgroundColor: "white" }}
      />
    </div>
      </div>
    </div>

  )
}